module.exports = __webpack_public_path__ + "img/20220112_103405.8c54f7a5.jpg";